module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAR1JREFUWAljYBgFoyEwsCHACLP+////eUC2AoxPK5qRkbGIFLORHXgcqNGCFM3kqAU6EG4nMfpZkBTtBbIfI/HxMYWBkk5QBavxKRwQOWBysABiMKC1A5hobQGl5o86cDQEKQ0BSvWPpsHREKQ0BCjVP+jTIHJdTKln4fr/X2PQAXJmwwVIZ1xm1GJIA2mjiQOB5vIw/KegZYTU3qGVAx8yMDJgb/f9ZxAAeqAOFDpA0ARU9wHCRCGfo/BI5QCbMWS3Zv7fZpD5f5XhPxgD2YTsHvSZZNSBhKKQkPxoCBIKIULyoyFIKIQIyY+GIKEQIiQ/GoKEQoiQ/GgIEgohQvLkNrdAzaF+QoZjlWdi+AxsYkH0gtijYDQEBnkIAADNpDlAJcoChQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/pdf/Add-Text.png
// module id = vSzW
// module chunks = 1